import { reminderConstants } from "../constants";
import { reminderService } from "../services";
import { alertActions } from "./alertActions";

export const reminderActions = {
  getReminders,
  addReminder,
  deleteReminder
};

function getReminders() {
  return (dispatch) => {
    dispatch(request(reminderConstants.GET_REMINDERS_REQUEST));
    reminderService.getReminders().then(
      (res) => {
        console.log("user into reminderActions");
        if (res === undefined) {
          dispatch(alertActions.error("ارتباط با سرور برقرار نیست"));
          dispatch(
            failure(
              reminderConstants.GET_REMINDERS_FAILURE,
              "ارتباط با سرور برقرار نیست"
            )
          );
        } else if (res.success) {
          console.log("*********reminders received**********");
          console.log(res);
          dispatch(success(reminderConstants.GET_REMINDERS_SUCCESS, res.data));
        } else if (res.success === false) {
          dispatch(alertActions.error(res.message));
          dispatch(
            failure(
              reminderConstants.GET_REMINDERS_FAILURE,
              res.message.toString()
            )
          );
        }

        setTimeout(() => {
          dispatch(alertActions.clear());
        }, 1500);
      },
      (error) => {
        dispatch(
          failure(reminderConstants.GET_REMINDERS_FAILURE, error.toString())
        );
        console.log("occure error");
        console.log(error.toString());
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
}

function addReminder(param) {
  return (dispatch) => {
    dispatch(request(reminderConstants.ADD_REMINDER_REQUEST));
    reminderService.addReminder(param).then(
      (res) => {
        console.log("user into reminderActions(addReminder)");
        if (res === undefined) {
          dispatch(alertActions.error("ارتباط با سرور برقرار نیست"));
          dispatch(
            failure(
              reminderConstants.ADD_REMINDER_FAILURE,
              "ارتباط با سرور برقرار نیست"
            )
          );
        } else if (res.success) {
          console.log(res);
          dispatch(success(reminderConstants.ADD_REMINDER_SUCCESS, res));
        } else if (res.success === false) {
          dispatch(alertActions.error(res.message));
          dispatch(
            failure(
              reminderConstants.ADD_REMINDER_FAILURE,
              res.message.toString()
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(reminderConstants.ADD_REMINDER_FAILURE, error.toString())
        );
        console.log("occure error");
        console.log(error.toString());
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
}

function deleteReminder(reminderId) {
  return (dispatch) => {
    dispatch(request(reminderConstants.DELETE_REMINDER_REQUEST));
    reminderService.deleteReminder(reminderId).then(
      (res) => {
        if (res === undefined) {

          dispatch(alertActions.error("ارتباط با سرور برقرار نیست"));

          dispatch(failure(reminderConstants.DELETE_REMINDER_FAILURE, "ارتباط با سرور برقرار نیست"));

        } else if (res.success) {

          dispatch(alertActions.success(res.message));

          dispatch(getReminders());

          dispatch(success(reminderConstants.DELETE_REMINDER_SUCCESS, res));

        } else if (res.success === false) {

          dispatch(alertActions.error(res.message));

          dispatch(failure(reminderConstants.DELETE_REMINDER_FAILURE, res.message.toString()));

        }
      },
      (error) => {
        console.log(error.toString());
        console.log("occurred error");
        dispatch(alertActions.error(error.toString()));
        dispatch(failure(reminderConstants.DELETE_REMINDER_FAILURE, error.toString()));
      }
    );
  };
}
function request(type) {
  return { type: type };
}

function success(type, data) {
  return { type: type, data };
}

function failure(type, error) {
  return { type: type, error };
}
